module.exports = __webpack_public_path__ + "img/gzh.fc0edbdc.webp";